import {getLoadingTime} from '@wix/music-shared/dist/src/utils/loadingTime/loadingTime';
import React, {useEffect} from 'react';
import {BI_SCHEMA} from '../../services/biLogger/biEvents';
import {fedopsLogger} from '../../services/fedopsLogger/fedopsLogger';
import {useBiLogger} from '../BiProvider/withBiLogger';

let isOpenedBiSent = false;

// test purposes only
export const resetIsOpenedBiSent = () => (isOpenedBiSent = false);

interface Props {
  getRequirement: string;
  hasExternalLinks: boolean;
}

export const BiOpened: React.FC<Props> = ({getRequirement, hasExternalLinks}) => {
  const biLogger = useBiLogger();
  useEffect(() => {
    if (isOpenedBiSent) {
      return;
    }

    fedopsLogger.appLoaded();
    isOpenedBiSent = true;
    biLogger.log(BI_SCHEMA.player.downloadPage.opened, {
      // eslint-disable-next-line camelcase
      loading_time: getLoadingTime(),
      externalLink: hasExternalLinks,
      getOption: getRequirement,
    });
  }, [biLogger, hasExternalLinks, getRequirement]);

  return null;
};
